import { gql } from 'Utils/apolloClient'

const sendMembershipEmailQuery = gql`
  query Campground($slug: String!, $email: String) {
    campground(slug: $slug) {
      sendMembershipEmail(email: $email)
    }
  }
`

export default sendMembershipEmailQuery
